var map = {
	"./sfi.json": "Nx0q",
	"./sfm.json": "GpRI"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "rxMO";


//////////////////
// WEBPACK FOOTER
// ./data/insurance_types ^\.\/.*\.json$
// module id = rxMO
// module chunks = 1